export const TABLE = 'table';
export const PLAYER = 'player';
export const FLOP_TYPE = 'flop';
export const TURN_TYPE = 'turn';
export const RIVER_TYPE = 'river';